import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Row, Col, Button, Container } from "reactstrap";
import "assets/styles/components/iconProperty.scss";
import "assets/styles/components/lists.scss";
import {
  COINNIK_MARKET_BASE_TOKEN,
  COINNIK_MARKET_URL_BASE_TOKENS,
} from "configs/constants";

export default function Guide() {
  const { t } = useTranslation();
  return (
    <div className="bg-primary-one" id="start">
      <Container className="py-4">
        <div className="d-flex flex-column justify-content-center ">
          <span className="fs-6 text-warning-light fw-medium pb-2">
            {t("Guide")}
          </span>
          <span className="fs-5 text-light fw-bold">
            {t("Where should I start?")}
          </span>
        </div>
        <Row className="align-items-center">
          <Col xs="12" sm="12" lg="6" xl="6">
            <article className="pb-3 progressbar-step list ">
              <ul>
                <li>
                  <span>`</span>
                </li>
                <li className="d-flex flex-row justtify-content-around">
                  <span className=" d-flex justify-content-end text-secondary-five-light ms-5">
                    {t("Step{{number}}", { number: "۱" })}
                  </span>
                  <span className=" d-flex justify-content-start text-light  me-5">
                    {t("Enter information and register at Coinnik Market")}
                  </span>
                </li>
                <li className="d-flex flex-row justtify-content-around">
                  <span className=" d-flex justify-content-end text-secondary-five-light  ms-5">
                    {t("Step{{number}}", { number: "۲" })}
                  </span>
                  <span className=" d-flex justify-content-start text-light me-5">
                    {t("Email and mobile verification in no time")}
                  </span>
                </li>
                <li className="d-flex flex-row justtify-content-around">
                  <span className=" d-flex justify-content-end text-secondary-five-light  ms-5">
                    {t("Step{{number}}", { number: "۳" })}
                  </span>
                  <span className=" d-flex justify-content-start text-light me-5">
                    {t("Buy or sell the desired digital currency")}
                  </span>
                </li>
              </ul>
            </article>
          </Col>
          <Col xs="12" sm="12" md="12" lg="6" xl="6">
            <video
              controls
              autoPlay
              loop
              muted
              className="w-100 border-radius-1"
            >
              <source
                src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
                type="video/mp4"
              ></source>
            </video>
          </Col>
        </Row>
        <Row className="my-3">
          <Col xs="12" md="6" lg="2" className="d-flex justify-content-center">
            <a
              href={COINNIK_MARKET_URL_BASE_TOKENS + COINNIK_MARKET_BASE_TOKEN}
            >
              <Button size="lg" color="warning">
                {t("Enter the market")}
              </Button>
            </a>
          </Col>
          <Col
            xs="12"
            md="6"
            lg="1"
            className="d-flex justify-content-center align-items-center  mt-4 mt-md-0 "
          >
            <Link to="/user-guide" className="text-warning-light me-2">
              {t("Know more")}
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
